/**
 * Configurazione per l'ambiente di sviluppo (dev) - v. analisi funzionale §8.
 * Sostituisce environment.ts quando si esegue `ng serve` o una build con configurazione "development"
 * (v. angular.json - fileReplacements). clientId/tenantId/apiScope vanno valorizzati con i dati
 * della App Registration Entra ID di RowS (ambiente dev).
 */
export const environment = {
  production: false,
  entraId: {
    /** Application (client) ID della App Registration del frontend RowS in Entra ID. */
    clientId: '16bcb775-53ac-4a5b-a2bc-76868df6d999',
    /** Directory (tenant) ID di Trafilerie del Monferrato in Entra ID. */
    tenantId: '41f9172f-5a61-4dd6-bcb8-44c54a073830',
    redirectUri: 'https://rows-dev.trafileriemonferrato.com/rows/dashboard',
    postLogoutRedirectUri: 'https://rows-dev.trafileriemonferrato.com/',
    /** Scope esposto dall'API RowS, es. api://<api-client-id>/access_as_user. */
    apiScope: 'api://16bcb775-53ac-4a5b-a2bc-76868df6d999/access_as_user',
  },
  /** Base URL di TrafilerieDelMonferrato.RowS.Api (Core) in sviluppo - v. Properties/launchSettings.json. */
  apiBaseUrl: 'https://api-rows-core-dev.trafileriemonferrato.com',
  googleMaps: {
    /** Maps JavaScript API key lato browser (diversa dalla Geocoding API key server-side, v.
     * GoogleMaps:ApiKey in appsettings del backend) - da valorizzare a mano: a differenza di
     * clientId/tenantId sopra (non segreti), questa chiave va restretta per referrer HTTP nella
     * Google Cloud Console, non protetta per segretezza tramite commit. */
    apiKey: 'AIzaSyBIfVGBprscgDPS117JW7RlYizRY_x_F_0',
  },
};
